import { render } from "./UserGoldList.vue?vue&type=template&id=f5b398d8"
import script from "./UserGoldList.vue?vue&type=script&lang=js"
export * from "./UserGoldList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__